import {FilterPanel} from './filter-panel.model';
import {TemplateRef} from '@angular/core';

export class FilterPanelHandler {
  panel: FilterPanel;

  constructor(panel: FilterPanel) {
    this.panel = panel;
  }

  setPanelHeader(text: string) {
    this.panel.name = text;
  }

  setPanelExtraTemplate(templateRef: TemplateRef<any>) {
    this.panel.extraTemplate = templateRef;
  }
}
